import React from "react";
// import HeroImg from "./assets/images/hero-1.png";
import { useNavigate } from "react-router-dom";
// import LocationImage from "./assets/images/locationImage.png";
import Alhaja from "./assets/images/alhaja.png";
import Speaking from "./assets/images/speaking.png";
import Nurses from "./assets/images/nurse2.png";
import Tv from "./assets/images/tv.png";
import locationIcon from "./assets/icons/location (2).png";
import Phone from "./assets/icons/phoone.png";
import Time from "./assets/icons/time.png";
import Direction from "./assets/icons/diretion.png";
import Phone2 from "./assets/icons/phone5.png";
import Gmail from "./assets/icons/gmail4.png";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import Map from "./components/Map";
// ..
AOS.init();

const Location = () => {
  const navigate = useNavigate();

  const location = [
    {
      id: 1,
      img: Speaking,
      title: "CLEAR ICON OMU ARAN",
      desc: "Opposite Ajuloopin house along general hospital",
      phone: "+234 705 114 1387",
    },
    {
      id: 2,
      img: Alhaja,
      title: "CLEAR ICON MEDIC DIAGNOSTICS TAIWO",
      desc: "Forgo Building, Beside Mama Ifeoma Textile Hub, Taiwo Oke, Ilorin.",
      phone: "07057142840",
    },
    {
      id: 3,
      img: Nurses,
      title: "CLEAR ICON MEDIC DIAGNOSTICS ALOR",
      desc: "Opposite Sayi Compound, Close to Balode Junction, Alore, Ilorin, Kwara State.",
      phone: "07051141174",
    },
    {
      id: 4,
      img: Speaking,
      title: "CLEAR ICON MEDIC DIAGNOSTICS OLORUNSOGO",
      desc: "Shopping Complex, Opposite Peculiar Grace Supermarket, Olorunsogo Road, Close to Geri Alimi Roundabout. Ilorin, Kwara State.",
      phone: "09157776753",
    },
  ];
  return (
    <div>
      <section
        style={{ backgroundImage: `url(${Tv})` }}
        className="w-full h-[60vh] md:h-[70vh] lg:h-[100vh] relative  flex items-start justify-center flex-col gap-3 bg-center bg-cover"
      >
        <div className="bg-gradient-to-r md:h-[70vh] lg:h-[100vh] from-[#1C022180]/100 to-[#1C022180]/50 h-[60vh] w-full absolute top-0"></div>
        <div
          data-aos="fade-in"
          data-aos-delay="0"
          data-aos-duration="1000"
          className="z-10 lg:px-24 md:px-10 px-4 "
        >
          <div className="lg:w-[75%] md:w-[85%] text-white flex flex-col gap-4">
            <h1 className="md:text-5xl text-3xl text-white font-semibold md:leading-[3.5rem]">
              Advanced Medical Diagnostics for Your Health
            </h1>
            <p className="md:text-lg text-base lg:text-base md:w-[70%] lg:w-full">
              Accurate Results, Professional Care, Quick Turnaround
            </p>
          </div>
          <button
            onClick={() => navigate("/book-appointment")}
            className="font-semibold mt-8 rounded-full py-3 lg:px-7 px-6 md:px-5 bg-white text-primaryPurple md:text-[0.75rem] lg:text-base"
          >
            Book Your Test Now
          </button>
        </div>
      </section>

      <section className="lg:px-24 md:px-10 px-4 py-10 bg-lightGrey">
        <h1 className="text-xl text-center font-semibold text-primaryPurple">
          Our Locations
        </h1>

        <div className="grid md:grid-cols-2 grid-cols-1 grid-flow-row justify-center place-items-center gap-5 py-6">
          {location.map((item) => (
            <div
              key={item?.id}
              className="lg:w-[35rem] w-full lg:h-[32rem] h-[26rem] rounded-lg bg-white relative"
            >
              <img src={item.img} className="w-full h-[60%]" alt="" />
              <div className="flex items-start gap-2 p-4">
                <img src={locationIcon} alt="" />
                <div className="">
                  <h1 className="">{item.title}</h1>
                  <p className="text-sm text-[#4A5568] font-thin pt-1">
                    {item.desc}
                  </p>
                  <div className="flex items-center gap-1 pt-2">
                    <img src={Phone} alt="" />
                    <p className="text-yellow">{item.phone}</p>
                  </div>
                </div>
              </div>

              <div className=" flex justify-between px-4 py-3 border-t absolute bottom-0 w-full">
                <div className="flex items-center gap-2 w-full">
                  <img src={Time} alt="" />
                  <p className="text-[0.7rem] lg:text-base text-[#4A5568]">
                    Mon - Sat: 8:00 AM - 6:00 PM
                  </p>
                </div>

                <div className="flex items-center float-right w-[50%] gap-2">
                  <img src={Direction} alt="" />
                  <p className=" text-[0.75rem]  md:text-base text-[#4A5568]">
                    Get Directions
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <h1 className="text-xl font-semibold text-center py-5">Find Us on Map</h1>
      <Map />

      <section className="bg-white flex flex-col items-center lg:px-24 md:px-10 px-4 text-center py-10">
        <h1 className="font-semibold text-xl">Need Help?</h1>
        <p className="text-gray-400 py-5">
          Our team is here to assist you with any questions about our services
        </p>

        <div className="flex items-center md:text-base text-sm gap-5">
          <div className="flex items-center gap-2">
            <img src={Phone2} alt="" />
            <p className="text-gray-400">+234 705 114 1387</p>
          </div>
          <div className="flex items-center gap-2">
            <img src={Gmail} alt="" />
            <p className="text-gray-400">contact@clearicon.com</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Location;
